import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const ImpressumPage = () => {
  return (
    <div className="pt-20 pb-16 min-h-screen bg-white">
      <SEO
        title="Impressum"
        description="Impressum der LAIzyones – Einzelunternehmen, Inhaber David Ehrle. Angaben gemäß § 5 TMG."
        path="/impressum"
        breadcrumbs={[
          { name: 'Startseite', url: '/' },
          { name: 'Impressum' },
        ]}
      />
      <div className="container-custom max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-600 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="heading-xl text-3xl md:text-4xl text-gray-900 mb-10">Impressum</h1>

        <div className="prose prose-gray max-w-none
          [&_h2]:font-['Space_Grotesk'] [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:text-gray-900 [&_h2]:mt-10 [&_h2]:mb-3
          [&_h3]:font-['Space_Grotesk'] [&_h3]:font-semibold [&_h3]:text-base [&_h3]:text-gray-900 [&_h3]:mt-6 [&_h3]:mb-2
          [&_p]:text-gray-600 [&_p]:leading-relaxed [&_p]:mb-3
          [&_a]:text-emerald-600 [&_a]:no-underline hover:[&_a]:underline
        ">
          <p className="text-sm text-gray-500 mb-6">Angaben gemäß § 5 TMG</p>

          <p>
            <strong className="text-gray-900">Laizyones</strong><br />
            Einzelunternehmen
          </p>

          <h3>Inhaber:</h3>
          <p>David Ehrle</p>

          <p>
            Ferdinand-Lentjes-Straße 32<br />
            39167 Wellen<br />
            Deutschland
          </p>

          <p>
            Telefon: 0172 1771141<br />
            E-Mail: <a href="mailto:info@laizyones.de">info@laizyones.de</a>
          </p>

          <p>Unternehmensform: Einzelunternehmen</p>

          <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:</h2>
          <p>
            David Ehrle<br />
            Ferdinand-Lentjes-Straße 32<br />
            39167 Wellen
          </p>

          <h3>Operative Projektleitung:</h3>
          <p>David Ehrle</p>

          <h3>Steuernummer:</h3>
          <p>105/215/02350 — Finanzamt Magdeburg</p>

          <h3>Wirtschafts-Identifikationsnummer:</h3>
          <p>DE459919567 (gemäß § 139c AO)</p>

          <h3>Umsatzsteuer-ID:</h3>
          <p>Es liegt keine Umsatzsteuer-Identifikationsnummer vor.</p>

          <h2>Haftung für Inhalte</h2>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
            Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          </p>

          <h2>Haftung für Links</h2>
          <p>
            Unsere Website enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
            Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          </p>

          <h2>Urheberrecht</h2>
          <p>
            Die durch Laizyones erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
            deutschen Urheberrecht.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
